import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import TableIdButton from "@lib/components/MiniComponents/Buttons/TableIdButton";
import { shortenString } from "@lib/helpers/StringHelper";
import { ColumnConfig, generateColumns } from "@lib/helpers/TableHelper";
import { MarketPlaceTraderAnalysis } from "@lib/types/MarketPlace";
import { TableColumnsProps } from "@lib/types/General";
import { IntlShape } from "react-intl";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";
import { LanguageLabel } from "@lib/components/MiniComponents/Others";
import { Image } from "antd";
import { AppTag } from "@lib/components/AppComponents";

type Props<T> = TableColumnsProps<T> & {
  handleSelectItem: (item: T) => void;
  messages: IntlShape["messages"];
};

const getColumns = <T extends MarketPlaceTraderAnalysis>(
  props: Props<T>,
): ColumnsType<T> => {
  const { handleSelectItem } = props;

  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (v, r) => (
        <TableIdButton text={`#${shortenString(r.id)}`} textToBeCopied={r.id} />
      ),
      width: "180px",
      filterType: "search",
    },
    {
      title: "common.imageUrl",
      dataIndex: "imageUrl",
      key: "imageUrl",
      width: "150px",
      render: (url) =>
        url ? (
          <Image
            src={url}
            alt="Image"
            style={{ maxWidth: "100%", maxHeight: "30px" }}
          />
        ) : (
          "-"
        ),
    },
    {
      title: "Symbol",
      dataIndex: "symbol",
      key: "symbol",
      fixed: "left",
      width: "150px",
      filterType: "search",
      render: (text) => <AppTag color="blue">{text}</AppTag>,
    },
    {
      title: "common.language",
      dataIndex: "language",
      key: "language",
      width: "150px",
      render: (d) => (d ? <LanguageLabel languageCode={d} /> : "-"),
    },
    {
      title: "Analysis",
      dataIndex: "analysis",
      key: "analysis",
      width: "150px",
      render: (arr: string[] | undefined) =>
        arr && arr.length > 0 ? `${arr.length} item(s)` : "-",
    },
    {
      title: "common.createdAt",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "150px",
      render: (d) => (d ? dayjs(d).format("DD/MM/YYYY HH:mm") : "-"),
    },
    {
      title: "common.createdBy",
      dataIndex: "createdBy",
      key: "createdBy",
      width: "150px",
      filterType: "dropdown",
    },
    {
      title: "common.updatedAt",
      dataIndex: "updatedAt",
      width: "150px",
      render: (d) => (d ? dayjs(d).format("DD/MM/YYYY HH:mm") : "-"),
    },
    {
      title: "common.updatedBy",
      dataIndex: "updatedBy",
      width: "160px",
      filterType: "dropdown",
    },
    {
      title: "common.actions",
      dataIndex: "actions",
      key: "actions",
      className: "order-table-action",
      fixed: "right",
      width: "110px",
      render: (_, record) => (
        <StyledFlex className="actions">
          <ActionButton
            type="quickLook"
            onClick={() => handleSelectItem(record)}
            noLabel
          />
        </StyledFlex>
      ),
    },
  ];

  return generateColumns(props, columnsConfig);
};

export default getColumns;
